import React from "react";
import { motion } from "framer-motion";
import { fadeUp, viewport } from "@/lib/motion";
import { WORKFLOW } from "@/data/smartContainer";
import SectionHeader from "./SectionHeader";

export default function HowItWorks() {
  return (
    <section id="how" className="py-24 sm:py-32 bg-slate-50/60 border-y border-slate-200/70" data-testid="how-it-works-section">
      <div className="dm-container">
        <SectionHeader
          eyebrow="How SmartContainer™ Works"
          title="One connected procurement workflow, end to end."
          description="From product selection to shipment, every stage flows through a single coordinated operation."
        />
        <div className="mt-16 relative max-w-3xl mx-auto">
          <div className="absolute left-[19px] sm:left-6 top-2 bottom-2 w-px bg-slate-200" aria-hidden />
          <motion.div initial={{ scaleY: 0 }} whileInView={{ scaleY: 1 }} viewport={{ once: true, amount: 0.1 }}
            transition={{ duration: 1.4, ease: "easeInOut" }} style={{ transformOrigin: "top" }}
            className="absolute left-[19px] sm:left-6 top-2 bottom-2 w-px bg-blue-600" aria-hidden />
          <div className="space-y-4">
            {WORKFLOW.map((step, i) => (
              <motion.div key={step.label} variants={fadeUp} initial="hidden" whileInView="visible" viewport={viewport}
                transition={{ delay: i * 0.05 }} className="relative flex items-center gap-5 pl-0"
                data-testid={`workflow-step-${i + 1}`}>
                <div className="relative z-10 shrink-0">
                  <div className="grid place-items-center h-10 w-10 sm:h-12 sm:w-12 rounded-full bg-white border-2 border-slate-200 shadow-sm">
                    <step.icon className="h-4 w-4 sm:h-5 sm:w-5 text-blue-600" strokeWidth={1.75} />
                  </div>
                </div>
                <div className="dm-card dm-card-hover flex-1 px-5 py-4 flex items-center justify-between">
                  <span className="text-sm sm:text-base font-semibold text-slate-900">{step.label}</span>
                  <span className="text-xs font-bold text-slate-300 tabular-nums">{String(i + 1).padStart(2, "0")}</span>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
